import { jsx as _jsx } from "react/jsx-runtime";
import ObjectCard from '../../../v2/components/generic/ObjectView/ObjectCard';
import { Status } from './Status';
export const LNSBaseView = ({ allowedActions, transactionFunctions, viewObject }) => {
    return _jsx(ObjectCard, { allowedActions, transactionFunctions, viewObject, additionalTabs: { Status } });
};
